export default "__VITE_ASSET__NQrlMJQA__"